<template>
  <div class="tags-dropdown-container">
    <tags-input
      :id="document.id"
      ref="tagsInput"
      v-bind="$props"
      boundary="window"
      :value="document.tags"
      :right="true"
      @input="updateTags"
      @hidden="$emit('hidden')"
      @shown="$emit('shown')"
    >
      <slot />
    </tags-input>
  </div>
</template>

<script>
import TagsInput from './TagsInput';
import { mapGetters } from 'vuex';

export default {
  components: {
    'tags-input': TagsInput,
  },
  props: {
    document: {
      type: Object,
      required: true,
    },
    ...TagsInput.props,
  },
  computed: {
    ...mapGetters({
      getDocumentById: 'getDocumentById',
    }),
  },
  mounted() {
    if (this.$refs) {
      const el = this.$refs.tagsInput?.$el;
      if (el) {
        ['.select-input-search', '.list-with-scroll-overhangs'].forEach(
          (selector) => {
            el.querySelector(selector).addEventListener('click', (evt) => {
              evt.stopPropagation();
            });
          },
        );
      }
    }
  },
  methods: {
    updateTags(tags) {
      const origDoc = this.getDocumentById(this.document.id) || this.document;
      origDoc.tags = tags.map(
        (tag) =>
          this.$store.state.tags.list.find(({ value }) => value === tag) || {
            value: tag,
          },
      );
      this.$store
        .dispatch('updateDocument', {
          document: this.document,
          data: {
            id: this.document.id,
            customer_id: this.document.customer_id,
            tags,
          },
        })
        .then(
          () => {
            this.$store.dispatch('getTags');

            this.$notify({
              group: 'api',
              type: 'success',
              duration: 2000,
              text: 'Tags successfully updated.',
            });
          },
          (error) => {
            this.$notify({
              group: 'api',
              type: 'error',
              duration: 5000,
              text: error.response,
            });
          },
        );
    },
  },
};
</script>
